<template>
    <q-page class="q-pa-md">
        <q-dialog v-model="dialogVisualizador" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vista previa PDF</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDF" />
                    </div>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class="col-12">
                <q-table dense title="Mis Contratos" class="shadow-1" :data="dataList" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetContratos()"
                            no-caps class="q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="nregistro" :props="props" @click="verItem(props.row)">{{ props.row.nregistro
                            }}</q-td>
                            <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre }}</q-td>
                            <q-td key="plazos" :props="props" @click="verItem(props.row)">{{ props.row.plazos }}</q-td>
                            <q-td key="vehiculo" :props="props" @click="verItem(props.row)">{{ props.row.marca + " " +
                                props.row.modelo + " " + props.row.color }}</q-td>
                            <q-td key="nserie" :props="props" @click="verItem(props.row)">{{ props.row.nserie }}</q-td>
                            <q-td key="nmotor" :props="props" @click="verItem(props.row)">{{ props.row.nmotor }}</q-td>
                            <q-td key="montotoralvehiculo" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.montotoralvehiculo) }}</q-td>
                            <q-td key="fechacontrato" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechacontrato) }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VisualizadorContrato.vue";
import moment from 'moment';
export default {
    components: {
        VisualizadorPDF
    },
    data() {
        return {
            loading: false,
            dataList: [],
            columns: [
                { name: 'nregistro', label: 'Registro', field: 'nregistro', align: 'center', sortable: true },
                { name: 'nombre', label: 'Cliente', field: 'nombre', align: 'center', sortable: true },
                { name: 'plazos', label: 'Plazos', field: 'concepto', align: 'center', sortable: true },
                { name: 'vehiculo', label: 'Vehiculo', field: 'monto', align: 'center', sortable: true },
                { name: 'nserie', label: 'N. Serie', field: 'tipo', align: 'center', sortable: true },
                { name: 'nmotor', label: 'N. Motor', field: 'fechacreacion', align: 'center', sortable: true },
                { name: 'montotoralvehiculo', label: 'Monto Total del Vehiculo', field: 'fechamaximapago', align: 'center', sortable: true },
                { name: 'fechacontrato', label: 'Fecha de contrato', field: 'fechacontrato', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogVisualizador: false,
            selectContrato: null
        }
    },
    async mounted() {
    },
    computed: {
        userStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
        this.GetContratos()
    },

    methods: {
        async verItem(item) {
            console.log(item)
            this.selectContrato = item
            this.$store.state.auth.objetoContrato = item
            this.dialogVisualizador = true
        },

        async GetContratos() {
            this.loading = true
            try {
                let respuesa = await axios.get('Contratos/GetCcontratoListCliente/' + this.userStore._id)
                console.log(respuesa)
                this.dataList = respuesa.data.lista
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },

        descargarPDF() {
            const fileName = 'CONTRATO_' + this.selectContrato.nregistro + this.selectContrato.nombre + '.pdf';
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Contrato;
            link.download = fileName;
            link.click();
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>